export function productNameSizeHandler(name: string, end: number = 50) {
    const truncatedName = name.slice(0, end)
    return truncatedName
}
